export const editableBoxClasses = {
  root: "EditableBox-root",
};
